import { actions } from './owner_clinic/actions'
import { getters } from './owner_clinic/getters'
import { state } from './owner_clinic/state'
import { mutations } from './owner_clinic/mutations'

export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions
}